module.exports = __webpack_public_path__ + "img/mq.c5b09af2.svg";